import { Box, BoxProps, Paper, Typography } from "@mui/material"

export const PaperBox = ({ 
    children, 
    title,
    ...props        
}: PaperBoxProps) => {

    const boxStyle: BoxProps = { component: Paper, p: 2, display: "flex", flexDirection: "column", gap: 1 }

    return (
        <Box {...boxStyle} {...props}>
            {title && <Typography variant="h6" mb={1}>
                {title}
            </Typography>}
            {children}
        </Box>
    )
}

interface PaperBoxProps extends BoxProps {
    title?: string
}
